import './TraceTimeLines.scss';

type TraceTimeLinesPros = {
  traceDuration: number;
};

const getNumMs = (traceDuration: number): number => {
  let numMs = 1;

  if (traceDuration < 100) {
    if (traceDuration > 10) {
      numMs = 2;
    }
    if (traceDuration > 20) {
      numMs = 5;
    }
    if (traceDuration > 50) {
      numMs = 10;
    }
  } else {
    const mostSignificantNumber = parseInt(traceDuration.toString()[0], 10);

    if (mostSignificantNumber < 3) {
      numMs = 2.5;
    } else if (mostSignificantNumber < 5) {
      numMs = 5;
    } else if (mostSignificantNumber > 4) {
      numMs = 10;
    }
  }

  // Sets numMs order of magnitude based on duration length
  // eslint-disable-next-line no-restricted-properties
  return numMs * Math.pow(10, traceDuration.toString().length - 2);
};

/**
 * This component shows lines for the trace waterfall view. We draw vertical lines to indicate
 * a time axis in ms.
 *
 * @props traceDuration -   Duration of the trace.
 */
const TraceTimeLines = ({ traceDuration }: TraceTimeLinesPros): JSX.Element => {
  const markers = [];

  const numMs = getNumMs(traceDuration);
  for (let i = 0, len = Math.floor(traceDuration / numMs) + 1; i < len; i++) {
    markers.push(
      <div className="TraceTimeLines__Marker" style={{ left: `calc((100% / ${traceDuration}) * ${numMs * i})` }}>
        <div className="TraceTimeLines__Line" />
        <div className="TraceTimeLines__Text">{`${numMs * i}ms`} </div>
      </div>,
    );
  }

  return <div className="TraceTimeLines">{markers}</div>;
};

export default TraceTimeLines;
